<template>
<div
    v-if="section != null"
>

    <m-showdown
        v-if="section.header_content_markdown != null"
        :value="section.header_content_markdown"
    />

    <v-checkbox
        v-for="(item, index) in section.acknowledgements"
        :key="'acb_'+index"
        :label="item.specimen"
        v-model="item.accepted"
        v-on:change="onChangeCb(item,$event)"
        :disabled="item.accepted"
    />

    <m-showdown
        v-if="section.footer_content_markdown != null"
        :value="section.footer_content_markdown"
    />
    
</div>
</template>

<script>
export default {
    props: {
        section: {
            type: Object,
            default: function() { return {}; },
        },
    },

    methods: {
        onChangeCb(item, value) {

            if ( value == false ) 
                return;
            
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/set-acknowledgement',
            
                'params' : {
                        'organization_id': item.organization_id,
                        'acknowledgement_id': item.acknowledgement_id,
                        'specimen': item.specimen,
                        'value': value,
                    },
            
                'on_success': (data) => {
                        this.$emit('reload-profile');
                    },
            
                'on_error': 'Unable to save state',
            });

        }
    },
}
</script>

<style lang="scss" scoped>

</style>
